<div class="container" [ngSwitch]="mode">
  <div *ngSwitchDefault>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!isLoading">
      <div style="padding: 20px">
        <span class="input">
          <mat-form-field>
            <mat-label>Soc List</mat-label>
            <mat-select
              [(ngModel)]="socId"
              (selectionChange)="socSelect($event)"
              matNativeControl
              required
            >
              <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">{{
                soc.SOC_NAME
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>

      <table style="width: 100%">
        <tr class="back">
          <th>
            Name
            <button
              class="add"
              style="margin-left: 5px"
              mat-raised-button
              color="basic"
              (click)="addNew()"
              *ngIf="role === 'Administrator'"
            >
              Add New
            </button>
          </th>
          <th>Template</th>
          <th>SLA</th>
          <th>Machine Code</th>
          <th>
            <input
              type="text"
              class="form-control"
              style="margin-left: 10px"
              id="search-text"
              aria-describedby="search-text"
              [(ngModel)]="searchText"
              (input)="onSearch()"
              placeholder="Search"
              autofocus
            />
          </th>
        </tr>
        <tr class="td" *ngFor="let item of filterddata">
          <td>{{ item.name }}</td>
          <td>{{ item?.service_price | currency : "₦" }}</td>
          <td>{{ item?.tat?.TotalOnlineMinutes }}</td>
          <td>{{ item?.machine_code }}</td>
          <td style="width: 100px" *ngIf="role === 'Administrator'">
            <button mat-raised-button color="primary" (click)="edit(item)">
              Edit
            </button>
            <button
              mat-raised-button
              color="primary"
              style="margin-left: 5px"
              (click)="delete(item)"
            >
              Delete
            </button>
          </td>
        </tr>
      </table>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
          <p>{{ Errors }}</p>
        </div>
      </div>
      <div class="last"></div>
    </div>
  </div>

  <form
    [formGroup]="groupForm"
    (ngSubmit)="onSubmit($event)"
    class="post"
    *ngSwitchCase="'add'"
  >
    <div class="post">
      <div class="title">Create Item</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="name" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Machine Code</mat-label>
            <input formControlName="machine_code" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Price</mat-label>
            <input
              type="number"
              formControlName="service_price"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Sub Department</mat-label>
            <mat-select formControlName="sub_dept_id" matNativeControl required>
              <mat-option *ngFor="let sub of subs" [value]="sub.id">{{
                sub.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>SOC</mat-label>
            <mat-select formControlName="soc_id" matNativeControl required>
              <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">{{
                soc.SOC_NAME
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Department</mat-label>
            <mat-select formControlName="dept_id" matNativeControl required>
              <mat-option *ngFor="let dept of depts" [value]="dept.id">{{
                dept.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Direct Revenue</mat-label>
            <mat-select
              formControlName="direct_revenue"
              matNativeControl
              required
            >
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Result Template</mat-label>
            <mat-select
              formControlName="result_format_id"
              matNativeControl
              required
            >
              <mat-option *ngFor="let result of results" [value]="result.Id">{{
                result.Name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select formControlName="status" matNativeControl required>
              <mat-option value="Active">Active</mat-option>
              <mat-option value="Inactive">Inactive</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Price Editable</mat-label>
            <mat-select
              formControlName="price_editable"
              matNativeControl
              required
            >
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>One Time</mat-label>
            <mat-select formControlName="one_time" matNativeControl required>
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Daily</mat-label>
            <input formControlName="Daily" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Doctor Required</mat-label>
            <mat-select formControlName="doctor_reqd" matNativeControl required>
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>NABL Accredited</mat-label>
            <mat-select
              formControlName="NABL_Accredited"
              matNativeControl
              required
            >
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Report Type</mat-label>
            <input formControlName="report_type" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Release Dr Fee When Unsettled</mat-label>
            <mat-select
              formControlName="release_dr_fee_when_unsettled"
              matNativeControl
              required
            >
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Methodology</mat-label>
            <input formControlName="methodology" matInput placeholder="" />
          </mat-form-field>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
          <p>{{ Errors }}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
          <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
  <form
    [formGroup]="groupForm"
    (ngSubmit)="onSubmit($event)"
    class="post"
    *ngSwitchCase="'edit'"
  >
    <div class="post">
      <div class="title">Edit Item</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="name" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Machine Code</mat-label>
            <input formControlName="machine_code" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Price</mat-label>
            <input
              type="number"
              formControlName="service_price"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Sub Department</mat-label>
            <mat-select formControlName="sub_dept_id" matNativeControl required>
              <mat-option *ngFor="let sub of subs" [value]="sub.id">{{
                sub.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Department</mat-label>
            <mat-select formControlName="dept_id" matNativeControl required>
              <mat-option *ngFor="let dept of depts" [value]="dept.id">{{
                dept.name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Direct Revenue</mat-label>
            <mat-select
              formControlName="direct_revenue"
              matNativeControl
              required
            >
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Result Template</mat-label>
            <mat-select
              formControlName="result_format_id"
              matNativeControl
              required
            >
              <mat-option *ngFor="let result of results" [value]="result.Id">{{
                result.Name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select formControlName="status" matNativeControl required>
              <mat-option value="Active">Active</mat-option>
              <mat-option value="Inactive">Inactive</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Price Editable</mat-label>
            <mat-select
              formControlName="price_editable"
              matNativeControl
              required
            >
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>One Time</mat-label>
            <mat-select formControlName="one_time" matNativeControl required>
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Daily</mat-label>
            <input formControlName="Daily" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Doctor Required</mat-label>
            <mat-select formControlName="doctor_reqd" matNativeControl required>
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>NABL Accredited</mat-label>
            <mat-select
              formControlName="NABL_Accredited"
              matNativeControl
              required
            >
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Report Type</mat-label>
            <input formControlName="report_type" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Release Dr Fee When Unsettled</mat-label>
            <mat-select
              formControlName="release_dr_fee_when_unsettled"
              matNativeControl
              required
            >
              <mat-option value="Y">Yes</mat-option>
              <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Methodology</mat-label>
            <input formControlName="methodology" matInput placeholder="" />
          </mat-form-field>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
          <p>{{ Errors }}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
          <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
        <button
          class="create"
          mat-raised-button
          (click)="price()"
          color="primary"
        >
          Edit Price
        </button>
      </div>
    </div>
  </form>

  <form
    [formGroup]="groupFormPrice"
    (ngSubmit)="onSubmit1($event)"
    class="post"
    *ngSwitchCase="'price'"
  >
    <div class="post">
      <div class="title">Edit Price</div>
      <div class="form">
        <!-- <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="item_id" matInput placeholder="" />
          </mat-form-field>
        </span> -->
        <span class="input">
          <mat-form-field>
            <mat-label>Price</mat-label>
            <input
              type="number"
              formControlName="amount"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </span>

        <!-- <span class="input">
          <mat-form-field>
            <mat-label>SOC</mat-label>
            <mat-select formControlName="soc_id" matNativeControl required>
              <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">{{
                soc.SOC_NAME
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span> -->
      </div>

      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
          <p>{{ Errors }}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
          <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
        <button
          class="create"
          mat-raised-button
          (click)="back()"
          color="primary"
        >
          Back
        </button>
      </div>
    </div>
  </form>
</div>
